module.exports = __webpack_public_path__ + "stockLibrary/simulator/006-1fcdf7ee88945e5bf010088ab1897bb8.png";